(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skrubbis"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skrubbis-landing')) {
    customElements.define('skrubbis-landing', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('.skrubbis-form');
        if (!form) return;
        const button = form.querySelector('button[type="submit"]');
        const pending = form.querySelector('[data-bundle-pending]');
        const error = form.querySelector('[data-bundle-error]');
        const selected = () => form.querySelector('input[name="quantity"]:checked');
        const ready = radio => radio && !radio.disabled && (radio.value === '1' || (this.dataset.bundleActive === 'true' && Boolean(radio.dataset.code)));
        const sync = () => {
          const radio = selected();
          button.disabled = !ready(radio);
          pending.hidden = !radio || radio.value === '1' || ready(radio);
          if (radio) form.querySelector('[data-pack-total]').textContent = radio.dataset.total;
        };
        sync();
        this.addEventListener('change', event => {
          if (event.target.matches('input[name="quantity"]')) sync();
        });
        form.addEventListener('submit', async event => {
          const radio = selected();
          if (!ready(radio)) { event.preventDefault(); return; }
          if (radio.value === '1') return;
          event.preventDefault();
          button.disabled = true;
          error.hidden = true;
          const root = window.Shopify?.routes?.root || '/';
          try {
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: form.elements.id.value, quantity: Number(radio.value) }] })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || this.dataset.cartError);
            window.location.assign(root + 'discount/' + encodeURIComponent(radio.dataset.code) + '?redirect=' + encodeURIComponent(root + 'cart'));
          } catch (exception) {
            error.textContent = exception.message || this.dataset.cartError;
            error.hidden = false;
            sync();
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
